import { Mutation } from 'vuex';
import { IModuleState, IMountOptionRecord, IMountRecord, IOptionRecord } from './types';

// 列表
export const setFilters: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 详情
export const setFilterDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 选项
export const setFilterOptions: Mutation<IModuleState> = (state, payload) => {
  state.options.data = payload.data;
  state.options.selected = (payload.data as IOptionRecord[]).filter((item) => item.entityType);
  state.options.loading = !!payload.loading;
};

// 待挂载列表
export const setFilterMounts: Mutation<IModuleState> = (state, payload) => {
  state.mounts.data = payload.data;
  state.mounts.selected = (payload.data as IMountRecord[]).filter((item) => item.entityType);
  state.mounts.loading = !!payload.loading;
};

// 可用的属性列表
export const setFilterProps: Mutation<IModuleState> = (state, payload) => {
  state.props.data = payload.data;
  state.props.loading = !!payload.loading;
};

// 挂载的选项列表
export const setMountOptions: Mutation<IModuleState> = (state, payload) => {
  state.mountOptions.data = payload.data;
  state.mountOptions.selected = (payload.data as IMountOptionRecord[]).filter((item) => item.entityType);
  state.mountOptions.loading = !!payload.loading;
};

export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setSaveLoading: Mutation<IModuleState> = (state, payload) => {
  state.saveLoading = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
